<template>
  <div class="left-container">
    <div class="card card2">
      <div class="card-slip"></div>
      <div class="card-title">
        <div class="icon"></div>
        <div class="ship-info">
          <span class="label">基本信息</span>
          <span>
            <span class="ship-name">{{shipName}}</span>
            <span class="ship-IMO">(IMO：{{currentAisShipData.imo}})</span>
          </span>
        </div>
      </div>
      <basic-info class="card-info"
                  :currentAisShipData="currentAisShipData"
                  :currentNoonData="currentShipData.noon_report"></basic-info>
    </div>
    <!--<div class="card card2">
      <div class="card-slip"></div>
      <div class="card-title">
        <div class="icon"></div>
        <span class="label" @click="tabChangeHandler('liquid')">油、水情况</span>
        <span class="label" @click="tabChangeHandler('roblubs')">滑油情况</span>
      </div>
      <liquid-condition v-if="tabName=='liquid'" 
        :clientWidth="clientWidth"
        :oilInfo="currentShipData.oil_info"
        :changeWidth="changeWidth"
        class="card-condition change-flex"
      />
      <rob-lubs v-else
        :clientWidth="clientWidth"
        :robLubsData="currentShipData.rob_info"
        :changeWidth="changeWidth"
        class="card-condition change-flex"
      />
    </div>
    <div class="card card2">
      <div class="card-slip"></div>
      <div class="card-title">
        <div class="icon"></div>
        <div class="chart-tab">
          <span class="label tab-label"
                @click="changeManage('ship-check')">船舶检查</span>
          <span class="label"
                @click="changeManage('crew-info')">船员换班</span>
           <span class="label"
                @click="showManage='manage-cost'">管理成本</span>
        </div>
      </div>
      <ship-manage class="card-condition change-width"
                   :clientWidth="clientWidth"
                   :showManage="showManage"
                   :changeWidth="changeWidth"
                   :checkInfo="currentShipData.inspection_info"
                   :crewInfo="crewInfo"
                   :manageInfo="manageInfo"
                   @clearManageInterval="clearManageInterval"></ship-manage>
    </div>-->
  </div>
</template>

<script>
import { defineComponent } from "vue"
import basicInfo from "./components/basicInfo.vue"
import shipManage from "./components/shipManage.vue"
import liquidCondition from "./components/liquidCondition.vue"
import robLubs from './components/robLubs.vue'
export default defineComponent({
  name: "LeftBar",
  components: { basicInfo },
  // shipSpeed, shipCog,collaborationInfo, crewInfo, manageCost
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    clientHeight: {
      type: Number,
      default: () => {
        return null;
      },
    },
    mmsi: {
      type: String,
      default: () => {
        return null;
      },
    },
    shipName: {
      type: String,
      default: () => {
        return null;
      },
    },
    currentAisShipData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    currentShipData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    crewInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    manageInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      showManage: "ship-check",
      interval: null, //切换
      tabName: 'liquid'
    };
  },
  watch: {
    shipName(newV) {
      if (newV) {
        this.showManage = "ship-check";
        if (this.interval) {
          this.clearManageInterval();
        }
        this.setManageInterval();
      }
    },
  },
  mounted() {
    this.setManageInterval();
  },
  computed: {},
  methods: {
    changeManage(type) {
      this.showManage = type;
      this.clearManageInterval();
    },
    tabChangeHandler(type) {
      this.tabName = type
    },
    // 循环
    setManageInterval() {
      let that = this;
      this.interval = setInterval(function () {
        //do whatever here..
        if (that.showManage == "ship-check") {
          that.showManage = "crew-info";
        } else {
          that.showManage = "ship-check";
        }
      }, 10000);
    },
    clearManageInterval() {
      clearInterval(this.interval);
    },
  },
});
</script>

<style lang="scss">
@import "../styles/variables";
@media screen and (max-width: 1500px) {
  .left-container {
    position: absolute;
    top: 50px;
    left: 10px;
    height: 90vh;
    width: 350px;
    color: white;
    .card {
      margin: 0 0 2vh 0;
      width: 100%;
      height: 28vh;
      background: rgba(72, 156, 255, 0.2);
      box-shadow: 0px 2px 20px 0px #000f22;
      /* opacity: 0.4; */
      /* -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);
      border-radius: 4px; */

      .card-slip {
        width: 100%;
        height: 5px;
        background: linear-gradient(
          90deg,
          rgba(137, 221, 255, 0) 0%,
          rgba(137, 221, 255, 1) 50%,
          rgba(137, 221, 255, 0.22) 78%,
          rgba(137, 221, 255, 0) 100%
        );
        filter: blur(0.64px);
      }
      .card-title {
        height: 36px;
        line-height: 36px;
        /* padding: 0 0 0 5%; */
        display: flex;
        align-items: center;
        .icon {
          margin-left: 14px;
          width: 2px;
          height: 16px;
          background-color: rgba(99, 222, 254, 1);
        }
        .label {
          font-size: 16px;
          font-weight: 600;
          color: rgba(99, 222, 254, 1);
          margin-left: 4%;
        }
        .ship-info {
          width: 90%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .ship-name {
            font-size: 14px;
            margin-left: 2%;
          }
          .ship-IMO {
            font-size: 12px;
            margin-left: 2%;
          }
        }
      }

      .card-list {
        width: 290px;
        margin-left: 25px;
        margin-right: 5px;
        text-align: left;
        font-size: 12px;
      }

      .card-condition-min {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 30px;
        padding: 0;
        height: calc(100% - 120px);
        width: 260px;
      }

      .card-condition {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 50px);
        width: 300px;
      }
      .change-width {
        margin: 0 5%;
      }
      .change-flex {
        display: flex;
        flex-direction: column;
      }
      .card-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        height: calc(100% - 50px);
      }
    }
    .card2 {
      width: 350px;
      // height: 40vh;
    }
  }
}

@media screen and (min-width: 1501px) {
  .left-container {
    position: absolute;
    // top: $header-height-1500;
    top: calc($header-height-1920 + 10px);
    left: 1vh;
    height: 90vh;
    width: 24vw;
    color: white;

    .card {
      margin: 0 0 2vh 0;
      width: 100%;
      height: 38vh;
      background: rgba(72, 156, 255, 0.2);
      box-shadow: 0px 2px 20px 0px #000f22;
      /* opacity: 0.4; */
      /* -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);
      border-radius: 4px; */

      .card-slip {
        width: 100%;
        height: 5px;
        background: linear-gradient(
          90deg,
          rgba(137, 221, 255, 0) 0%,
          rgba(137, 221, 255, 1) 50%,
          rgba(137, 221, 255, 0.22) 78%,
          rgba(137, 221, 255, 0) 100%
        );
        filter: blur(0.64px);
      }
      .card-title {
        height: 36px;
        line-height: 36px;
        /* padding: 0 0 0 5%; */
        display: flex;
        align-items: center;

        .icon {
          margin-left: 4%;
          width: 1%;
          height: 16px;
          background-color: rgba(99, 222, 254, 1);
        }
        .label {
          font-size: 16px;
          font-weight: 600;
          color: rgba(99, 222, 254, 1);
          margin-left: 4%;
          cursor: pointer;
        }
        .ship-info {
          width: 90%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .ship-name {
            font-size: 14px;
            margin-left: 2%;
          }
          .ship-IMO {
            font-size: 12px;
            margin-left: 2%;
          }
        }
      }

      .card-list {
        width: 91%;
        margin-left: 9%;
        text-align: left;
        font-size: 12px;
      }

      .card-condition-min {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 120px);
        width: 82%;
      }

      .card-condition {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 50px);
        width: 82%;
      }
      .change-width {
        margin: 0 5%;
        width: 90%;
      }
      .change-flex {
        display: flex;
        flex-direction: column;
      }
      .card-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        height: calc(100% - 50px);
      }
    }
    .card2 {
      // height: 40vh;
    }
  }
}

@media screen and (min-width: 1921px) {
  .left-container {
    position: absolute;
    // top: 9vh;
    top: calc($header-height-2560 + 20px);
    left: 1vw;
    height: 90vh;
    width: 24vw;
    color: white;

    .card {
      margin: 0 0 3vh 0;
      width: 100%;
      height: 30vh;
      background: rgba(72, 156, 255, 0.2);
      box-shadow: 0px 2px 20px 0px #000f22;

      .card-slip {
        width: 100%;
        height: 8px;
        background: linear-gradient(
          90deg,
          rgba(137, 221, 255, 0) 0%,
          rgba(137, 221, 255, 1) 50%,
          rgba(137, 221, 255, 0.22) 78%,
          rgba(137, 221, 255, 0) 100%
        );
        filter: blur(1.1px);
      }
      .card-title {
        height: 56px;
        line-height: 56px;
        /* padding: 0 0 0 5%; */
        display: flex;
        align-items: center;

        .icon {
          margin-left: 4%;
          width: 1%;
          height: 30px;
          background-color: rgba(99, 222, 254, 1);
        }
        .label {
          font-size: 30px;
          font-weight: 600;
          color: rgba(99, 222, 254, 1);
          margin-left: 4%;
          cursor: pointer;
        }
        .ship-info {
          width: 90%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .ship-name {
            font-size: 24px;
            margin-left: 2%;
          }
          .ship-IMO {
            font-size: 20px;
            margin-left: 2%;
          }
        }
      }

      .card-list {
        width: 91%;
        margin-left: 9%;
        text-align: left;
        font-size: 24px;
      }

      .card-condition-min {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 210px);
        width: 82%;
      }

      .card-condition {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        width: 82%;
        height: calc(100% - 75px);
      }
      .change-width {
        margin: 0 5%;
        width: 90%;
      }
      .change-flex {
        display: flex;
        flex-direction: column;
      }
      .card-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        height: calc(100% - 75px);
      }
    }
    .card2 {
      // height: 40vh;
    }
  }
}

@media screen and (min-width: 2561px) {
  .left-container {
    position: absolute;
    top: calc($header-height-4368 + 80px);
    left: 1vw;
    height: 90vh;
    width: 20vw;
    color: white;

    .card {
      margin: 0 0 3vh 0;
      width: 100%;
      height: 27vh;
      background: rgba(72, 156, 255, 0.2);
      box-shadow: 0px 2px 20px 0px #000f22;
      /* opacity: 0.4; */
      // -webkit-backdrop-filter: blur(6px);
      // backdrop-filter: blur(6px);
      // border-radius: 6px;

      .card-slip {
        width: 100%;
        height: 12px;
        background: linear-gradient(
          90deg,
          rgba(137, 221, 255, 0) 0%,
          rgba(137, 221, 255, 1) 50%,
          rgba(137, 221, 255, 0.22) 78%,
          rgba(137, 221, 255, 0) 100%
        );
        filter: blur(1.5px);
      }
      .card-title {
        height: 70px;
        line-height: 70px;
        /* padding: 0 0 0 5%; */
        display: flex;
        align-items: center;

        .icon {
          margin-left: 4%;
          width: 1%;
          height: 36px;
          background-color: rgba(99, 222, 254, 1);
        }
        .label {
          font-size: 36px;
          font-weight: 600;
          color: rgba(99, 222, 254, 1);
          margin-left: 4%;
        }
        .ship-info {
          width: 90%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .ship-name {
            font-size: 32px;
            margin-left: 2%;
          }
          .ship-IMO {
            font-size: 30px;
            margin-left: 2%;
          }
        }
      }

      .card-list {
        width: 91%;
        margin-left: 9%;
        text-align: left;
        font-size: 30px;
      }

      .card-condition-min {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 250px);
        width: 82%;
      }

      .card-condition {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 100px);
        width: 82%;
      }
      .change-width {
        margin: 0 5%;
        width: 90%;
      }
      .change-flex {
        display: flex;
        flex-direction: column;
      }
      .card-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        height: calc(100% - 100px);
      }
    }
    .card2 {
      // height: 40vh;
    }
  }
}

@media screen and (min-width: 6700px) {
  .left-container {
    position: absolute;
    top: calc($header-height-6720 + 30px);
    left: 1vw;
    height: 90vh;
    width: $sidebar-width;
    color: white;

    .card {
      margin: 0 0 4vh 0;
      width: 100%;
      height: 25vh;
      background: rgba(72, 156, 255, 0.2);
      box-shadow: 0px 2px 20px 0px #000f22;
      // -webkit-backdrop-filter: blur(8px);
      // backdrop-filter: blur(8px);
      // border-radius: 8px;

      .card-slip {
        width: 100%;
        height: 17px;
        background: linear-gradient(
          90deg,
          rgba(137, 221, 255, 0) 0%,
          #89ddff 50%,
          rgba(137, 221, 255, 0.22) 78%,
          rgba(137, 221, 255, 0) 100%
        );
        filter: blur(2px);
      }
      .card-title {
        height: 112px;
        display: flex;
        align-items: center;

        .icon {
          margin-left: 4%;
          width: 1%;
          height: 46px;
          background-color: rgba(99, 222, 254, 1);
        }
        .label {
          font-size: 46px;
          font-weight: 600;
          color: rgba(99, 222, 254, 1);
          margin-left: 4%;
        }
        .ship-info {
          width: 90%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .ship-name {
            font-size: 40px;
            margin-left: 2%;
          }
          .ship-IMO {
            font-size: 36px;
            margin-left: 2%;
          }
        }
      }

      .card-list {
        width: 91%;
        margin-left: 9%;
        text-align: left;
        font-size: 36px;
      }

      .card-condition-min {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: 320px;
        width: 82%;
      }
      .card-condition {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 9%;
        padding: 0;
        height: calc(100% - 15px);
        width: 82%;
      }
      .change-width {
        margin: 0 5%;
        width: 90%;
      }
      .change-flex {
        display: flex;
        flex-direction: column;
      }
      .card-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        height: calc(100% - 150px);
      }
    }
    .card2 {
      // height: 40vh;
    }
  }
}
</style>
<style lang="scss">
// 鼠标移入效果
.atooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #0617328c;
}

.atooltip.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  border-right-color: #0617328c;
}
.atooltip {
  background: #0617328c !important;
  border: #0617328c !important;
}
</style>
<style lang="scss" scoped>
.chart-tab {
  display: flex;
  width: 100%;
  .label {
    cursor: pointer;
    margin: 0 6% 0 4%;
  }
}
</style>